import { useEffect, useRef } from 'react';

/**
 * Drive a callback on every animation frame while `active` is true.
 * Ported verbatim from sites/my-fdi/src/hooks/useAnimationFrame.ts.
 */
export function useAnimationFrame(callback: (dt: number) => void, active: boolean) {
  const callbackRef = useRef(callback);
  const frameRef = useRef<number>(0);
  const prevTimeRef = useRef<number>(0);

  useEffect(() => {
    callbackRef.current = callback;
  });

  useEffect(() => {
    if (!active) return;

    const animate = (time: number) => {
      const dt = prevTimeRef.current ? time - prevTimeRef.current : 16;
      prevTimeRef.current = time;
      callbackRef.current(dt);
      frameRef.current = requestAnimationFrame(animate);
    };

    frameRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(frameRef.current);
  }, [active]);
}
